"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));
var createOverrides_1 = require("./createOverrides");
var createPalette_1 = require("./createPalette");
var createProps_1 = require("./createProps");
var createSpacing_1 = require("./createSpacing");
var createTypography_1 = require("./createTypography");
exports.createEpicTheme = function (options) {
    if (options === void 0) { options = {}; }
    var palette = createPalette_1.createPalette(options.palette);
    var typography = createTypography_1.createTypography(typeof options.typography === "function"
        ? options.typography(palette)
        : options.typography);
    var theme = createMuiTheme_1.default(__assign(__assign({}, options), { palette: palette,
        typography: typography, spacing: createSpacing_1.createSpacing(options.spacing), props: createProps_1.createProps(options.props) }));
    theme.overrides = createOverrides_1.createOverrides(theme, options.overrides);
    return theme;
};
//# sourceMappingURL=createEpicTheme.js.map